import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import CircularProgress, {
  circularProgressClasses,
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Chart from "react-apexcharts";
import { Padding } from '@mui/icons-material';
import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import './../../../../cssfiles/homepage.css';
import pointer from '../../../../images/pointer.png';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from "react";
import "./Linearprogressbarsimplienewjson.css";

const Linearprogressbarsimplienewjson = (props) => {
const tagaliascollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagaliascollectionvaluesnewjson);
const tagcollectionvaluesnewjson = useSelector((state) => state.mainpagedata.tagcollectionvaluesnewjson);
console.log("Linearprogressbarsimplienewjson-inside linearprogress chart**********************tagcollectionvaluesnewjson********************", tagcollectionvaluesnewjson);
  const theme = useSelector((state) => state.themedata.theme)
  const [valuepf, setValuePF] = useState(0)
  const [valuepfwithoutrounding, setValuePFWithoutRounding] = useState(0)
  const [tagAlias, setTagAlias] = useState('');
  var seriesprogress2= [
    {
      name: "Process 3",
      color:"#00943D",
      data: [23]
    },
    {
      name: "Process 4",
      color:"#DC272D",
      data: [212]
    },
    {
      name: "Process 5",
      color:"#00943D",
      data: [23]
    }
  ];
  var optionsProgress2 = {
      chart: {
          type: "bar",
          stacked: true,
          sparkline: {
              enabled: true
          },
      },
    grid:{
        show:false,    
    },
    plotOptions: {
        bar: {
            horizontal: true,
            barHeight: "50%",
            barWidth: "100%",
            /*colors: {
              backgroundBarColors: ["#00943D"]
              colors: ["#00943D","#DC272D","#00943D"],
            } */
        }
    },
    stroke: {
        width: 0
    },
    tooltip: {
        enabled: false
    },
    xaxis: {
    },
    yaxis: {
      show:true,
    },
  };
  
  useEffect(() => {
    const tagProperties = props.widgetprop?.props?.extended?.tagprops || [];
    let sum = 0.0;
    var tagalias = '';
    tagProperties.forEach(tagvalueprops => {
        if (
          tagvalueprops &&
          tagvalueprops.tagid &&
          tagcollectionvaluesnewjson &&
          Object.prototype.hasOwnProperty.call(tagcollectionvaluesnewjson, tagvalueprops.tagid)
        ) {
            var nestedvalue = tagcollectionvaluesnewjson[tagvalueprops.tagid];
            tagalias = tagaliascollectionvaluesnewjson ? tagaliascollectionvaluesnewjson[tagvalueprops.tagid] : '';
            var nestedvaluelength = Array.isArray(nestedvalue) ? nestedvalue.length : 0;
            if(
              tagvalueprops.data_values_configuration &&
              tagvalueprops.data_values_configuration.type_of_operation === "AVG" &&
              Array.isArray(nestedvalue)
            ){
                sum = nestedvalue.reduce((accumulator, currentValue) => {
                    if(currentValue && currentValue.y != null){
                        return Number(accumulator) + Number(currentValue.y);
                    }else{
                        nestedvaluelength = nestedvaluelength - 1;
                        return Number(accumulator);
                    }
                }, 0.0)

                if(nestedvaluelength === 0){
                    sum = "0.97";
                }else{  
                    sum = sum / nestedvaluelength;
                }
            }
        }
    });
    setValuePFWithoutRounding(sum);
    let sumToSet = 0;
    if (typeof sum === "number" && !isNaN(sum)) {
      sumToSet = Number(sum).toFixed(2);
    } else {
      sumToSet = sum; // e.g. "Improper Data"
    }
    setValuePF(sumToSet);
    setTagAlias(tagalias);
    //setleftAlignment(sum * 400)
  },[props.widgetprop,tagcollectionvaluesnewjson])

    // useEffect(() => {
    //     for(let i=0; i<historicaldata.length; i++) {
    //         if(props.widgetprop.props.extended.tagprops[0].tagid === historicaldata[i].tagid) {
    //             var sum = 0
    //             var count = 0
    //             for(let j=0; j<historicaldata[i].histdata.length; j++) {
    //                 if(historicaldata[i].histdata[j].value > 0) {
    //                     sum = sum + historicaldata[i].histdata[j].value
    //                     count = count + 1
    //                 }
    //             }
    //             var avg = []
    //             avg.push((sum / count).toFixed(2))
    //             //setSerice(avg)
    //             if(sum != 0) {
    //                 setOptions((sum / count).toFixed(2))
    //                 setleftAlignment((sum / count).toFixed(2) * 410)
    //             } else {
    //                 setOptions(0.00)
    //                 setleftAlignment(0)
    //             }
    //             //console.log("PF ",avg, historicaldata[i].histdata)
    //         }
    //     }
    // },[historicaldata])

  return (
    <>
    <Typography className="tooltip" sx={{fontFamily:"Roboto",fontSize:"58px",fontWeight:400,alignItems:"center",marginTop:"20px",color:theme=='dark'?"white":"black"}}>{valuepf}<span className="tooltiptext">{tagAlias +":"+valuepf}</span></Typography>
    <Stack spacing={2} sx={{ flexGrow: 1,paddingTop:0,paddingLeft:2 }}>
      {/* <BorderLinearProgress variant="determinate" value={50} /> */}
      
      <div style={{position:'relative'}}>
          <div style={{position:'absolute',top:"7px", left:(valuepf==0)?("210px"):((valuepf>=0)?(203+(valuepf*100*2.024)+""+"px"):(203-(Math.abs(valuepf)*100*2.024)+""+"px"))}}><img src={pointer} alt="Smartcomm Logo" /></div>
      </div>
      <Chart options={optionsProgress2} series={seriesprogress2} type='bar' height="15%" width="114%" />
      <div style={{display:'flex',flexDirection:"row",height:"15%",width:"97%"}}>
            <Typography sx={{fontFamily:"Roboto",fontSize:"15px",fontWeight:400,marginLeft:"5px",alignItems:"center",color:theme=='dark'?"white":"black"}}>{"Lead"}</Typography>
            <div style={{flexGrow: 1}}></div>
            <Typography sx={{fontFamily:"Roboto",fontSize:"15px",fontWeight:400,alignItems:"center",color:theme=='dark'?"white":"black"}}>{"Lag"}</Typography>
      </div>
    </Stack>
    {/*
    <div style={{display:"flex",flexDirection:"row",marginleft:"10px",marginTop:"40px",alignItems:"baseline"}}>
          <Typography sx={{paddingLeft:"10px",fontSize:"14px",fontWeight:400,fontFamily:"Roboto",color:theme=='dark'?"white":"black"}}>Estimated Surcharge (INR)</Typography>
          <Typography sx={{fontSize:"24px",fontWeight:400,fontFamily:"Roboto",color:theme=='dark'?"white":"black",marginLeft:"190px",}}>240/-</Typography>
    </div>*/}
    </>
  );
};

export default Linearprogressbarsimplienewjson;
